import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IModalInformation, IUser, IUserCreateRequest, IUserEditRequest } from '../interfaces/user-definitions.interface';
import { BehaviorSubject, Observable, of, shareReplay, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserDefinitionService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl + '/user-definitions/';

    $userInfo = new BehaviorSubject<IUser | null>(null);
    private userInfo$: Observable<IUser> | null = null;

    getUsers(): Observable<IUser[]> {
        const apiUrl = `${this.baseUrl}users`;
        return this.http.get<IUser[]>(apiUrl);
    }

    getUsersByFilter(wsUser: boolean, notOkUser: boolean): Observable<IUser[]> {
        const apiUrl = `${this.baseUrl}users?wsUser=${wsUser}&notOkUser=${notOkUser}`;
        return this.http.get<IUser[]>(apiUrl);
    }

    getModalInformation(): Observable<IModalInformation> {
        const apiUrl = `${this.baseUrl}modal-information`;
        return this.http.get<IModalInformation>(apiUrl);
    }

    createUser(userRequest: IUserCreateRequest) {
        const apiUrl = `${this.baseUrl}users`;
        return this.http.post(apiUrl, userRequest);
    }

    editUser(userRequest: IUserEditRequest) {
        const apiUrl = `${this.baseUrl}users`;
        return this.http.put(apiUrl, userRequest);
    }

    getUserInfo(): Observable<IUser> {
        const cachedUser = this.$userInfo.getValue();
        if (cachedUser) {
            return of(cachedUser);
        }

        if (!this.userInfo$) {
            const apiUrl = `${this.baseUrl}user-information`;
            this.userInfo$ = this.http.get<IUser>(apiUrl).pipe(
                tap((user) => this.$userInfo.next(user)),
                shareReplay(1)
            );
        }

        return this.userInfo$;
    }
}
